import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export enum LayerPosition {
    Left = "LEFT",
    Right = "RIGHT",
}

export enum LayerPlatform {
    Desktop = "DESKTOP",
    Mobile = "MOBILE",
}

export enum LayerType {
    Text = "TEXT",
    Image = "IMAGE",
    Missing = "MISSING",
}

export class BannerLayer extends BaseModel {
    @Expose()
    platform: LayerPlatform = LayerPlatform.Desktop;
    @Expose()
    type: LayerType = LayerType.Missing;
    @Expose()
    private from?: LayerPosition;
    @Expose()
    sources: string[] = [];
    @Expose()
    alt = "";

    get position() {
        switch (this.type) {
            case LayerType.Text:
                return this.from ?? LayerPosition.Left;
            case LayerType.Image:
                return this.from ?? LayerPosition.Right;
            default:
                return LayerPosition.Left;
        }
    }
}
